import React from "react";
import "./Route.scss";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class Route extends React.Component {
  constructor(props) {
    super(props);
    this.dom = { markers: [] };
  }

  componentDidMount() {
    const tl = gsap
      .timeline({
        ease: "none",
        scrollTrigger: {
          trigger: this.dom.root,
          start: "10% 50%",
          end: "70% 50%",
          scrub: 1,
          invalidateOnRefresh: true,
          // markers: true,
        },
      })
      .add([
        gsap.fromTo(
          this.dom.markers,
          { autoAlpha: 0.5, scale: 0 },
          { stagger: 0.5, scale: 1, duration: 0.1, autoAlpha: 1 }
        ),
        gsap.fromTo(
          this.dom.path,
          { strokeDasharray: "0% 200%" },
          { strokeDasharray: "200% 200%", duration: 5 }
        ),
      ]);
  }

  render() {
    return (
      <div className="Route" ref={(el) => (this.dom.root = el)}>
        <svg
          aria-hidden="true"
          viewBox="0 0 500 560"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M192.039 524.534L184.775 516.706C183.417 515.242 181.468 514.475 179.477 514.621L170.148 515.302C168.268 515.439 166.421 514.761 165.065 513.451C161.714 510.213 157.325 506.06 156.837 505.938C156.307 505.806 151.072 502.754 147.6 500.701C146.74 500.193 146.011 499.493 145.463 498.659L133.573 480.533C133.026 479.699 132.297 479.003 131.444 478.485C127.287 475.963 120.648 471.735 119.565 470.249C118.536 468.839 114.693 463.406 112.106 459.742C111.324 458.634 110.905 457.312 110.905 455.955V447.546C110.905 446.907 110.812 446.271 110.629 445.659L106.58 432.14C106.209 430.901 106.211 429.58 106.587 428.343L114.007 403.912C114.848 401.141 117.403 399.247 120.298 399.247H124.273C125.141 399.247 126.001 399.075 126.803 398.741L139.246 393.555C140.047 393.221 140.907 393.049 141.775 393.049H144.039C145.729 393.049 147.354 392.398 148.577 391.232L152.911 387.098C156.147 384.011 155.425 378.664 151.485 376.548L150.65 376.099C150.01 375.755 149.432 375.308 148.939 374.776L142.212 367.516C141.086 366.3 140.46 364.704 140.46 363.047V355.432C140.46 353.688 141.275 352.045 142.663 350.989V350.989C143.788 350.134 144.546 348.884 144.785 347.492L145.377 344.051C146.058 340.084 150.112 337.655 153.932 338.925L156.837 339.891L172.313 344.229C173.156 344.465 174.039 344.531 174.909 344.421L192.981 342.145L201.635 341.331C202.486 341.251 203.337 341.49 204.021 342.002L204.701 342.511C206.122 343.574 208.163 343.043 208.886 341.422V341.422C208.949 341.278 209.025 341.141 209.112 341.01L212.733 335.591C213.477 334.477 214.543 333.617 215.789 333.126L228.645 328.058C228.964 327.933 229.272 327.783 229.567 327.609L238.687 322.247C239.334 321.866 240.043 321.599 240.78 321.457L248.518 319.973C249.139 319.853 249.774 319.825 250.403 319.887L265.376 321.366C267.333 321.559 269.274 320.866 270.666 319.477L278.552 311.609C279.58 310.582 280.92 309.925 282.362 309.741L300.254 307.452C301.501 307.293 302.767 307.494 303.903 308.032L308.526 310.222C313.493 312.575 318.983 308.158 317.748 302.803L315.905 294.811L315.738 293.311C315.396 290.239 312.96 287.82 309.886 287.499L301.277 286.6C299.78 286.444 298.382 285.778 297.316 284.715L293.592 280.999C291.621 279.032 291.102 276.037 292.298 273.522L298.002 261.52C298.625 260.209 298.797 258.728 298.49 257.309L297.396 252.247C297.07 250.742 297.284 249.171 297.998 247.807L300.503 243.025C300.976 242.123 301.232 241.123 301.253 240.105L302.496 177.346C302.524 175.927 303.011 174.554 303.884 173.434L308.481 167.537C308.91 166.987 309.248 166.372 309.484 165.716L313.975 153.2C314.376 152.082 314.467 150.877 314.238 149.712L313.248 144.677C312.901 142.912 313.293 141.081 314.332 139.612L316.45 136.619C316.96 135.898 317.32 135.081 317.507 134.218L319.826 123.547C320.314 121.305 319.597 118.97 317.934 117.388L309.991 109.828C308.943 108.831 308.254 107.515 308.029 106.086L307.077 100.032C306.94 99.1598 306.98 98.2691 307.194 97.4128L307.76 95.1542C308.156 93.5743 307.952 91.9038 307.186 90.4661L305.946 88.1377C305.44 87.1864 305.175 86.1253 305.175 85.0476V75.231"
            stroke="#F2F2F2"
            strokeOpacity="0.8"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
            ref={(el) => (this.dom.path = el)}
          />
        </svg>

        <ul>
          <li ref={(el) => this.dom.markers.push(el)}>
            <span>Barcelona</span>
          </li>
          <li ref={(el) => this.dom.markers.push(el)}>
            <span>Sabadell</span>
          </li>
          <li ref={(el) => this.dom.markers.push(el)}>
            <span>
              Vilanova
              <br />
              del Vallès
            </span>
          </li>
          <li ref={(el) => this.dom.markers.push(el)}>
            <span>
              L’Ametlla
              <br />
              del Vallès
            </span>
          </li>
          <li ref={(el) => this.dom.markers.push(el)}>
            <span>El Folló</span>
          </li>
        </ul>
      </div>
    );
  }
}

export default Route;
